import React, { useState } from 'react'
import Main from '../cpn/Main'
import { Tabs } from 'antd';
import ArapAdd from './ArapAdd';
import ArapClientList from './ArapClientList';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
function ArapList(props) {    
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_arap_active_key') || 'ArapClientList');
    return (
        <Main selectedKeys={['/ArapList']}>
            <Tabs items={[
                {
                    key: 'ArapAdd',
                    label: '新增',
                    children: <ArapAdd />,
                    icon: <PlusOutlined />,
                },
                {
                    key: 'ArapClientList',
                    label: '查询',
                    children: <ArapClientList />,
                    icon: <SearchOutlined />,
                    }
                ]} 
                activeKey={activeKey}
                onChange={(key) => {
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_arap_active_key', key)
                }}
                />
            </Main>
        )
    }
    export default ArapList